import React, { useState } from "react";
import * as faceapi from "face-api.js";
import { saveUser } from "./utils";

const RegisterFace = ({ videoRef, refreshUsers }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    age: "",
    role: "",
    joining: "",
    address: "",
    dob: "",
    salary: "",
    paidLeave: "",
    halfDay: "",
    aadhaar: "",
    pan: "",
    religion: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const captureFace = async () => {
    if (!videoRef.current || videoRef.current.readyState !== 4) {
      alert("Camera not ready");
      return null;
    }

    return await faceapi
      .detectSingleFace(videoRef.current, new faceapi.TinyFaceDetectorOptions())
      .withFaceLandmarks()
      .withFaceDescriptor();
  };

  const registerUser = async () => {
    if (!form.name.trim()) return alert("Enter name");

    const face = await captureFace();
    if (!face) return alert("Face not detected ❌");

    const nowtime = new Date();
    const time = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(nowtime);

    saveUser({
      ...form,
      descriptor: Array.from(face.descriptor),
      time,
    });

    refreshUsers();

    // Reset form
    setForm({
      name: "",
      phone: "",
      age: "",
      role: "",
      joining: "",
      address: "",
      dob: "",
      salary: "",
      paidLeave: "",
      halfDay: "",
      aadhaar: "",
      pan: "",
      religion: "",
    });

    alert("✅ User Registered");
  };

  return (
    <div className="Register-section">
      <div className="input-three-group">
 <div class="formlabeldiv">
        <input name="name" value={form.name} onChange={handleChange} type="text"/>
        <label>Name</label>
      </div>
      <div class="formlabeldiv">
        <input name="phone" value={form.phone} onChange={handleChange} type="number"/>
        <label> Phone no. </label>
      </div>
      <div class="formlabeldiv">
        <input name="age" value={form.age} onChange={handleChange} type="number"/>
        <label>Age</label>
      </div>

      <div class="formlabeldiv">
        <input name="role" value={form.role} onChange={handleChange} type="text"/>
        <label>Role</label>
      </div>
      <div class="formlabeldiv">
        <input
          type="date"
          name="joining"
          value={form.joining}
          onChange={handleChange}
        />{" "}
        <label>Joining Date </label>
      </div>
      <div class="formlabeldiv">
        <input
          type="date"
          name="dob"
          value={form.dob}
          onChange={handleChange}
        />{" "}
        <label>Date of birth </label>
      </div>
      <div class="formlabeldiv">
        <input name="salary" value={form.salary} onChange={handleChange} type="number"/>
        <label>Salary</label>
      </div>

      <div class="formlabeldiv">
        <input
          name="paidLeave"
          value={form.paidLeave}
          onChange={handleChange}
        type="number"/>
        <label> Paid Leave </label>
      </div>

      <div class="formlabeldiv">
        <input name="halfDay" value={form.halfDay} onChange={handleChange} type="number"/>
        <label> Half day </label>
      </div>
      <div class="formlabeldiv">
        <input name="aadhaar" value={form.aadhaar} onChange={handleChange} type="number"/>
        <label>Aadhar no. </label>
      </div>
      <div class="formlabeldiv">
        <input name="pan" value={form.pan} onChange={handleChange} type="text"/>
        <label>PAN no </label>
      </div>

      <div class="formlabeldiv">
        <input name="religion" value={form.religion} onChange={handleChange} type="text"/>
        <label>Religion</label>
      </div>

  
      </div>
     
    <div class="formlabeldiv">
        <textarea name="address" value={form.address} onChange={handleChange} />
        <label>Address</label>
      </div>
      <button onClick={registerUser} className="button" type="submit">
        Register
      </button>
    </div>
  );
};

export default RegisterFace;
